import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API_URL = "http://localhost/playstore/api";

// Create Translation Context
const TranslationContext = createContext();

let cache = {};

// Translation Provider Component
export function TranslationProvider({ children, defaultLang = "en" }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || defaultLang);
  const [translations, setTranslations] = useState(cache[lang] || {});
  const [loading, setLoading] = useState(!cache[lang]);

  useEffect(() => {
    if (cache[lang]) {
      setTranslations(cache[lang]);
      setLoading(false);
      return;
    }

    setLoading(true);
    axios
      .get(`${API_URL}/translations?lang=${lang}`)
      .then((res) => {
        cache[lang] = res.data;
        setTranslations(res.data);
      })
      .catch((err) => {
        console.error("Failed to load translations:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [lang]);

  const t = (key) => {
    if (!translations[key]) {
      // Auto-register missing translation key
      axios.post(`${API_URL}/translations`, { key }).catch(() => {});
    }
    return translations[key] || key;
  };

  const switchLanguage = (newLang) => {
    localStorage.setItem("lang", newLang);
    setLang(newLang);
  };

  return (
    <TranslationContext.Provider value={{ t, lang, switchLanguage, loading }}>
      {children}
    </TranslationContext.Provider>
  );
}

// Custom hook to use translation context
export function useTranslation() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useTranslation must be used within TranslationProvider");
  }
  return context;
}

// HOC for class components (optional)
export function withTranslation(Component) {
  return function TranslatedComponent(props) {
    const translation = useTranslation();
    return <Component {...props} {...translation} />;
  };
}